import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=014a38dd&scoped=true&"
import script from "./DiscountForm.vue?vue&type=script&lang=js&"
export * from "./DiscountForm.vue?vue&type=script&lang=js&"
import style0 from "./DiscountForm.vue?vue&type=style&index=0&id=014a38dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a38dd",
  null
  
)

export default component.exports